<template>
  <div id="set-create-details-tab">
    <div class="vx-col w-full">
        <div class="vx-row ">
          <div class="vx-col lg:w-1/2 sm:w-1/1 w-full mb-2 ">
              <vs-input class="w-full" label-placeholder="Set Name" v-model="data_local.set_name" @change="setUpdateData"/>
          </div>
          <div class="vx-col lg:w-1/2 sm:w-1/1 w-full mb-2 ">
            <vs-select class="w-full mt-5" placeholder="Set Status" v-model="data_local.status"  @change="setUpdateData">
              <vs-select-item :key="index" :value="option" :text="option | capitalize" v-for="(option,index) in statusOptions"/>
            </vs-select>
          </div>
        </div>
      <div class="vx-row  mb-4">
        <div class="vx-col w-full">
          <vs-input class="w-full" label-placeholder="Thumbnail URL" v-model="data_local.set_thumbnail"/>
        </div>
      </div>
        <div class="vx-row">
          <div class="vx-col w-full mt-2">
            <vs-textarea  label="Set Description" counter="400" :counter-danger.sync="set_description_counter" height="100px" v-model="data_local.set_description" @change="setUpdateData"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button color="success" type="filled" class="mb-2 mr-2"
                       @click="submitData">Create Set
            </vs-button>
            <vs-button color="warning" type="border" class="mb-2 ml-2"
                       @click="resetData">Reset
            </vs-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      retailer_options: [],
      set_description_counter: null,

      statusOptions: [
        'active',
        'hidden',
        'disabled'
      ]

    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    setUpdateData () {
      this.$emit('update_setData', this.data_local)
    },
    submitData () {
      this.$emit('insert_setData', this.data_local)
    },
    resetData () {
      this.data_local =  {set_name: undefined, set_description: undefined, set_status: undefined, set_code : undefined}
      this.setUpdateData()
    }
  }
}
</script>

<style scoped>

</style>
